module.exports = __webpack_public_path__ + "static/media/diners.51f25c07.svg";